<template>
  <div class="body">
    <div style="width: 100%;height: 500px;" v-if="datas==''" v-loading="loading"></div>
    <div v-else>
      <!-- 上部 -->
      <div style="width: 95%;overflow: hidden;margin: 0 auto;">
        <!-- 上部 -->
        <div style="width: 100%;overflow: hidden;">
          <!-- 左部CPU -->
          <div style="width: 49%;float: left;">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr style="background-color: rgb(246, 246, 246);">
                <td colspan="2">
                  <div style="padding: 10px;">
                    <el-tag size="medium">CPU</el-tag>
                  </div>
                </td>
              </tr>
              <tr style="background-color: rgb(246, 246, 246);">
                <td width="40%">
                  <div style="padding: 10px;">
                    属性
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    值
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    核心数
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.cpu.cpuNum}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    用户使用率
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.cpu.used}}%
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    系统使用率
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.cpu.sys}}%
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    当前空闲率
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.cpu.free}}%
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- 右部内存 -->
          <div style="width: 49%;float: right;">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr style="background-color: rgb(246, 246, 246);">
                <td colspan="3">
                  <div style="padding: 10px;">
                    <el-tag size="medium">内存</el-tag>
                  </div>
                </td>
              </tr>
              <tr style="background-color: rgb(246, 246, 246);">
                <td width="30%">
                  <div style="padding: 10px;">
                    属性
                  </div>
                </td>
                <td width="30%">
                  <div style="padding: 10px;">
                    内存
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    JVM
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    总内存
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.mem.total}}G
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.total}}MB
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    已用内存
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.mem.used}}G
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.used}}MB
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    剩余内存
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.mem.free}}G
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.free}}MB
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    使用率
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.mem.usage}}%
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.usage}}%
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 下部 -->
        <div style="width: 100%;overflow: hidden;margin-top: 10px;">
          <!-- 左部服务器信息	 -->
          <div style="width: 49%;float: left;">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr style="background-color: rgb(246, 246, 246);">
                <td colspan="2">
                  <div style="padding: 10px;">
                    <el-tag size="medium">服务器信息</el-tag>
                  </div>
                </td>
              </tr>
              <tr style="background-color: rgb(246, 246, 246);">
                <td width="40%">
                  <div style="padding: 10px;">
                    属性
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    值
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    服务器名称
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.sys.computerName}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    服务器IP
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.sys.computerIp}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    操作系统
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.sys.osName}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    系统架构
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.sys.osArch}}
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- 右部JAVA虚拟机信息 -->
          <div style="width: 49%;float: right;">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr style="background-color: rgb(246, 246, 246);">
                <td colspan="2">
                  <div style="padding: 10px;">
                    <el-tag size="medium">JAVA虚拟机信息</el-tag>
                  </div>
                </td>
              </tr>
              <tr style="background-color: rgb(246, 246, 246);">
                <td width="40%">
                  <div style="padding: 10px;">
                    属性
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    值
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    Java名称
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.name}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    Java版本
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.version}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    安装路径
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.home}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    项目路径
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.sys.userDir}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    启动时间
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.startTime}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="padding: 10px;">
                    运行时长
                  </div>
                </td>
                <td>
                  <div style="padding: 10px;">
                    {{datas.jvm.runTime}}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- 下部磁盘信息 -->
      <div style="width: 95%;overflow: hidden;margin: 0 auto;margin-top: 10px;">
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr style="background-color: rgb(246, 246, 246);">
            <td colspan="7">
              <div style="padding: 10px;">
                <el-tag size="medium">磁盘状态</el-tag>
              </div>
            </td>
          </tr>
          <tr style="background-color: rgb(246, 246, 246);">
            <td>
              <div style="padding: 10px;">
                盘符路径
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                文件系统
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                盘符类型
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                总大小
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                可用大小
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                已用大小
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                已用百分比
              </div>
            </td>
          </tr>
          <tr v-for="(cc,index) in datas.sysFiles" :key="index">
            <td>
              <div style="padding: 10px;">
                {{cc.dirName}}
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                {{cc.sysTypeName}}
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                {{cc.typeName}}
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                {{cc.total}}
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                {{cc.free}}
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                {{cc.used}}
              </div>
            </td>
            <td>
              <div style="padding: 10px;">
                {{cc.usage}}%
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      return {
        loading:true,
        datas:'',
        data:'',
        dialogVisible: false,
        timer:'',
      };
    },
    mounted(){
      this.timer=setInterval(this.getData_xieyi,60000);
      this.getData_xieyi();
    },
    destroyed(){
      window.clearInterval(this.timer);
      //console.log('销毁')
    },
    methods: {
      //颜色选取
      getcolor(data){
        //console.log(data);
        data=data*1;
        let color="";
        if(data>=0&&data<20){
          color="#14e6d5";
        }else if(data>=20&&data<40){
          color="#2de623";
        }else if(data>=40&&data<60){
          color="#e6ba09";
        }else if(data>=60&&data<80){
          color="#ff6700";
        }else if(data>=80&&data<=100){
          color="#e61616";
        }else {
          color="#a9e6da";
        }
        return color;
      },
      //查询
      getData_xieyi() {
        commonAPI('queryMemDisk','1').then(res => {
          this.datas = res.data.data.data;
          this.loading=false;
          //this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
        })
      },
      //修改前台确认处
      updateChcke(){
        this.$emit('Father_updateChcke', "");
        this.dialogVisible = false
      },
      handleOpen(){
        this.dialogVisible=true;
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
    }
  };
</script>

<style scoped>
  .body{
    min-width: 1180px;
    height: 100%;
  }
  .boxs{
    height: 100%;
    border-radius: 10px;
    border: 1px solid #ddd;
  }
  .title{
    margin: 10px 10px;color: #1fa1f1;font-size: 18px;
  }
  .content{
    margin: 10px 10px;font-size: 16px;width: 100%;overflow: hidden;
  }
  .content a{
    color: #000;
  }
  .content a:hover{
    color: #fff;
  }
  .flex{
    color: #aaa;
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
  }
  .on{
    width: 100%;
  }
  .off{
    width: 100%;display: none;
  }
  #notice:hover{
    background-color: #c5c5c5;
  }
  table{
    border-width: 1px;
    border-style: solid;
    border-color: rgb(230, 230, 230);
  }
  td{
    border-width: 1px;
    border-style: solid;
    border-color: rgb(230, 230, 230);
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/system/SystemType.vue